export const cardStyles = {
  minWidth: 'w-64',
  minHeight: 'min-h-96',
  categoryTypeBubble: 'size-12 rounded-full flex items-center justify-center',
  categoryTypeGlyph: 'size-8',
  metaGlyph: 'size-4 text-teal-600 shrink-0',
  title: 'text-denim-500 text-sm font-medium leading-4 line-clamp-3 mb-4',
  cta: 'w-full rounded-2xl am-3xl:rounded-3xl',
} as const;
